module.exports = __webpack_public_path__ + "static/img/icon-34.f77226e1.svg";